export enum StatementLevel {
  InnerBlock,
  Stitch,
  Knot,
  Top,
}
